import React, { useState } from 'react';

interface TestimonialData {
  quote: string;
  author: string;
  role: string;
}

const testimonials: TestimonialData[] = [
  {
    quote: "NexusAI transformed our customer service operations with their intelligent chatbot solution. We've seen a 40% reduction in response time and significantly improved customer satisfaction.",
    author: "Sarah Johnson",
    role: "CTO, GlobalTech"
  },
  {
    quote: "Their predictive analytics platform has given us insights we never thought possible. We can now forecast market trends with remarkable accuracy.",
    author: "Michael Chen",
    role: "Data Director, Finance Plus"
  },
  {
    quote: "Working with NexusAI has been a game-changer for our healthcare system. Their AI diagnostics assistant has helped our doctors make faster, more accurate decisions.",
    author: "Dr. Emily Rodriguez",
    role: "Medical Director, City Hospital"
  }
];

interface TestimonialsProps {
  language: string;
}

const Testimonials: React.FC<TestimonialsProps> = ({ language }) => {
  return (
    <section id="testimonials" className="py-20 px-4">
      <div className="max-w-6xl mx-auto text-center flex flex-col items-center justify-center min-h-[300px]">
        <h2 className="text-3xl font-bold mb-12 relative">
          {language === 'zh' ? '客戶評價' : 'What Our Clients Say'}
          <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-blue-500 rounded-full"></span>
        </h2>
        <div className="text-4xl font-bold text-blue-700 mb-4">Coming Soon</div>
        <div className="text-lg text-gray-600">This section will be updated with real client testimonials soon. Stay tuned!</div>
      </div>
    </section>
  );
};

export default Testimonials;